import $ from "jquery";
import { Klass, csl, u_ } from "@pressmedia/webappbase";

const { app } = window;

function addFmCsv(vuw) {
	if( !( vuw instanceof Klass("Vuw") ) ) {
		throw new TypeError("arguments[0] must be Vuw instance.");
	}
	
	// [fmCsv]
	vuw.add("fmCsv", {
		vuwType: "jbForm",
		app,
		inputIdPrefix: "csv",
		enableAddExecModeParam: false,	// modeパラメータを付与しない
		autoInit: false,
		popupKey: "csv-uploader",
		
		selector() {
			const $elm = $("<form/>").addClass("fm fm-csv");
			app.popup.addContent(this.popupKey, $("<div/>").append($elm));
			return $elm;
		},
		
		errorCallbacks: {
			INPUT(messages, methodName, errcode, errtype) {
				if( u_.isObject(messages) ) {
					const $preview = this.preview.get("field").$preview;
					const $dataArea = $preview.children(".data-table").children("tbody");
					const msgs = [];
					
					Object.keys(messages).forEach(k => {
						if(this.config.dataParams[k]) {
							return true;
						}
						
						let msg = messages[k];
						delete messages[k];
						
						if( (/^row-\d+$/).test(k) ) {
							const $rec = $dataArea.children(`.${k}`).addClass("has-error");
							
							Object.keys(msg).forEach(c => {
								let $col = $rec.children(`.${c}`);
								!$col.length && ( $col = $rec.children("td").eq(0) );
								
								if( u_.isObject(msg[c]) ) {
									msg[c] = Object.keys(msg[c]).map(m => `${m}: ${msg[c][m]}`);
								}
								
								Array.isArray(msg[c]) && ( msg[c] = msg[c].join("\n") );
								
								$("<div/>").addClass("error-messages").html( u_.textareaParse(msg[c], true) ).appendTo($col);
							});
							
						} else {
							if( u_.isObject(msg) ) {
								msg = Object.keys(msg).map(m => `${m}: ${msg[m]}`);
							}
							
							Array.isArray(msg) && ( msg = msg.join("<br>") );
							msgs.push(msg);
						}
					});
					
					!!msgs.length && this.alert( msgs.join("<br>") );
					
					return this.showPrompt(messages);
				} else
				if( Array.isArray(messages) ) {
					return this.alert( messages.join("<br>") );
				} else {
					return this.errorCallbacks.def.apply(this, arguments);
				}
			}
		},
		
		// [override] ajaxリクエスト送信 app.moduleの同関数を利用する
		_sendRequest(method, ajaxSetting, cb) {
			if(app.module) {
				const k = method.replace(/^aRequest|Upload$/g, "").toLowerCase();
				
				// for fileUploader
				const vuwForm = u_.isObject(this.execModeValues) ? this : this.container.getForm();
				
				if( u_.hasProperty(vuwForm.execModeValues, k) ) {
					ajaxSetting.endPoint = "csv";
					(k !== "exec") && (ajaxSetting.endPoint += `/${vuwForm.execModeValues[k]}`);
				}
				
				// 入力エラーコールバック関数を置き換え
				vuwForm._inputErrorCallbackOfModule = app.module.errorCallbacks.INPUT;
				app.module.errorCallbacks.INPUT = vuwForm.errorCallbacks.INPUT.bind(vuwForm);
				
				return app.module._sendRequest(method, ajaxSetting, (err, res) => {
					// 入力エラーコールバック関数を元に戻す
					app.module.errorCallbacks.INPUT = vuwForm._inputErrorCallbackOfModule;
					
					if( u_.isFunction(cb) ) {
						return cb(err, res);
					}
				});
				
			} else {
				return Klass(this.klass).prototype._sendRequest.apply(this, arguments);
			}
		},
		
		// [override] 子VuwSheet用のデフォルト設定の取得
		getDefaultSheetProp() {
			const prop = Klass(this.klass).prototype.getDefaultSheetProp.apply(this, arguments);
			
			// キャンセルボタンを先頭に追加
			prop.btns = {
				cancel: {
					text: "キャンセル",
					func: app.popup.hideContents.bind(app.popup, this.popupKey, () => {
						this.clearVal().setActiveSheet(0);
					})
				},
				...prop.btns
			};
			
			// リセットボタンは不要
			delete prop.btns.reset;
			
			return prop;
		},
		
		// [override] clearVal
		clearVal() {
			Klass(this.klass).prototype.clearVal.apply(this, arguments);
			this.fileFieldCallbacks.onDisSelect.call(this, "csv");
			return this;
		},
		
		// ファイル項目に関するコールバック集
		fileFieldCallbacks: {
			onUpload(res) {
				csl.log.orange("csv uploaded", res.data);
				
				const vuwField = this.preview.get("field");
				const $table = $("<table/>").addClass("data-table");
				
				if(vuwField.dataOption.length) {
					vuwField.dataOption = [];
					vuwField.$self.empty().off(".setVal");
				}
				
				$.fn.append.apply( $("<tbody/>"), res.data.csv["01"].map((rec, i) => {
					const val = String(i);
					const inpId = ["inp", vuwField.idStr, val].join("_");
					const $tr = $("<tr/>").addClass( "row-" + String(i) );
					const $inp = $("<input/>").addClass( vuwField.inpClassList.join(" ") ).attr({
						"type": vuwField.inpType,
						"name": vuwField.paramKey,
						"id": inpId
					}).val(val);
					
					vuwField.dataOption.push(val);
					
					$("<th/>").append(
						$inp,
						$("<label/>").attr("for", inpId).text( String(i + 1) )
					).appendTo($tr);
					
					return $.fn.append.apply( $tr, rec.map((v, j) => {
						return $("<td/>").addClass(`col-${String(j)}`).append(
							$("<p/>").html( u_.textareaParse(v) )
						);
					}) );
				}) ).appendTo($table);
				
				vuwField.$preview = $("<div/>").addClass("uploaded-data").append(
					$table
				).appendTo(vuwField.$self);
				
				vuwField.getInpReady(vuwField.$self);
				
				this.preview.$self.removeClass("hide");
			},
			
			onDisSelect(paramKey) {
				if(paramKey === "csv") {
					this.preview.$self.addClass("hide");
					const vuwField = this.preview.get("field");
					vuwField.dataOption = [];
					vuwField.$self.empty();
				}
			}
		},
		
		// [override] nextStepCallBacks
		nextStepCallBacks: {
			// begin cb if it's input sheet.
			beforeRequestNext($form) {
				const $dataTable = this.preview.get("field").$preview.children(".data-table");
				$dataTable.children("tbody").children(".has-error").removeClass("has-error")
				.find(".error-messages").remove();
				
				const _super = Klass(this.klass).prototype.nextStepCallBacks.beforeRequestNext;
				return _super.apply(this, arguments);
			},
			
			// success cb if it's input sheet. (before focus the next sheet.)
			beforeFocusNext(res) {
				this.preview.enableCols = !!res.enableCols ? res.enableCols : false;
				this.preview.disableRows = !!res.disableRows ? res.disableRows : false;
				
				const _super = Klass(this.klass).prototype.nextStepCallBacks.beforeFocusNext;
				return _super.apply(this, arguments);
			}
		},
		
		// 確認シートへ値がコピーされる際のコールバック
		onCopyToConfirmSheet($cloneSheet, config) {
			csl.log.gray("++ onCopyToConfirmSheet", {
				cols: this.preview.enableCols,
				rows: this.preview.disableRows
			});
			
			if( !Array.isArray(this.preview.enableCols) ) {
				return false;
			}
			
			if( !Array.isArray(this.preview.disableRows) ) {
				delete this.preview.disableRows;
			}
			
			const vuwfield = this.preview.get("field");
			const headerRow = vuwfield.getVal();
			const $field = $cloneSheet.find(`#${vuwfield.$self.attr("id")}_copied`);
			const $dataTable = $field.children(".uploaded-data").children(".data-table");
			
			$dataTable.children("tbody").children("tr").each((i, tr) => {
				if(i < headerRow) {
					return true;
				}
				
				const $tr = $(tr);
				if(this.preview.disableRows && this.preview.disableRows.indexOf(i) >= 0) {
					$tr.addClass("is-disable");
					return true;
				}
				
				$tr.children("td").each((j, td) => {
					this.preview.enableCols[j] && $(td).addClass("is-enable");
				});
			});
		},
		
		// submit成功コールバック
		async onSubmitSuccess(config, res) {
			await Promise.all([
				new Promise(resolve => app.alert("ファイルの内容を反映しました", resolve)),
				app.popup.hideContents(this.popupKey)
			]);
			
			await this.setActiveSheet(0);
			await this.clearVal();
			await app.initList();
		},
		
		onReady($self) {
			$("<button/>").addClass("btn-close hover-target").insertBefore($self)
			.on("click", e => {
				e.preventDefault();
				app.popup.hideContents(this.popupKey);
			});
			
			$self.on("change", ".inp[name='headerRowIndex']", e => {
				const $tr = $(e.currentTarget).closest("tr");
				$tr.siblings(".is-header-row").removeClass("is-header-row");
				$tr.addClass("is-header-row");
			});
		},
		
		async refresh() {
			this.removeChildren().$self.empty();
			this.state = {};
			this.config = {};
			this.resetMembers();
			u_.hasProperty(this, "preview") && (delete this.preview);
			
			const { csv } = app.module.config;
			
			if(u_.isObject(csv) && u_.isObject(csv.input) && u_.isObject(csv.input.config) ) {
				const { buttonText, config } = csv.input;
				
				if(buttonText) {
					config.sheet.inputs.title = buttonText;
				} else {
					config.sheet.inputs.title = this.getOther("funcHeader")._buttonText.csv.input;
				}
				
				// config
				const ajaxTimeoutTime = app.config.ajaxTimeoutTime;
				
				this.setConfig({
					...config,
					ajaxTimeoutTime,
					form: {
						...app.module.config.form,
						editFormStyle: "grid",
						editFormStyleOption: ["borderless"]
					}
				});
				
				// initialize form
				await this.initForm();
				
				const vuw = this.get("headerRowIndex.inputs");
				vuw.$self.addClass("hide");
				
				vuw.get("field").setProp({
					// [override] field._getCopiedInp
					_getCopiedInp(val) {
						const clones = [];
						
						if(
							this.$preview &&
							this.$preview instanceof $ &&
							this.$preview.length
						) {
							clones.push( this.$preview.clone() );
							clones[0].find("input").remove();
						} else {
							const _super = Klass(this.klass).prototype._getCopiedInp;
							clones.push( ..._super.apply(this, arguments) );
						}
						
						return clones;
					}
				});
				
				this.preview = vuw;
			}
			
			return true;
		}
	}, function() {
		// appから直接アクセス可能にする
		app.fm.csv = this;
	});
}

export default addFmCsv;
